<template>
    <div class="ObjectAppointment">
        <Button class="ObjectAppointment__button" @click="open = true" :disabled="object.shown === 1">
            <CarIcon v-if="!object.shown" />
            <CheckIcon v-else />
            <span class="text" v-if="!object.shown">
                {{!object.want_to_visit ? 'Записаться на просмотр' : 'Отказаться от показа'}}
            </span>
            <span class="text" v-else>Просмотрено</span>
        </Button>
        <Modal :open="open" @close="open = false">
            <div class="ObjectAppointment__modal">
                <div class="ObjectAppointment__title">
                    Хотите {{ !object.want_to_visit ? 'записаться на просмотр' : 'отказаться от просмотра' }} этого объекта?
                </div>
                <div class="ObjectAppointment__modal-body">
                    <img class="ObjectAppointment__person" v-if="broker.photo" :src="broker.photo" alt="person">
                    <div class="ObjectAppointment__text">
                        {{!object.want_to_visit ? 'Я узнаю о свободных датах и перезвоню вам.' : 'Вы всегда сможете записаться заново.'}}
                    </div>
                </div>
                <div class="ObjectAppointment__actions">
                    <Button :transparent="true" @click="open = false">Нет</Button>
                    <Button @click="onClick">Да, хочу</Button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import Button from "@/components/elements/Button";
import CarIcon from '@/assets/image/icons/car.svg?inline';
import CheckIcon from '@/assets/image/icons/checkmark.svg?inline';
import Modal from "@/components/Modal";
import axios from 'axios';

export default {
    name: "ObjectAppointment",
    components: {
        Button,
        CarIcon,
        CheckIcon,
        Modal,
    },
    props: {
        id: [String, Number],
        want_to_visit: [Number],
        shown: [Number],
    },
    data: () => ({
        open: false,
    }),
    computed: {
        object() {
            let obj = this.$store.state.objects.filter(object => object.id === this.$route.params.id);
            return obj[0];
        },
        broker() {
            return this.$store.state.broker;
        }
    },
    methods: {
        onClick() {
            let object_id = this.$route.params.id;
            let link = this.$route.params.link;
            let user_id = this.$route.params.user_id;
            let obj = this.$store.state.objects.filter(object => object.id === object_id);
            let data = axios.get('/api.php?action=want_to_visit&object_id='+object_id+'&link='+link+'&user_id='+user_id+'&flag='+(+!obj[0].want_to_visit));

            this.object.want_to_visit = !obj[0].want_to_visit;

            console.log(data.data);

            this.open = false;
        }
    }
}
</script>

<style lang="scss">
.ObjectAppointment {

  &__button {
    width: 100%;
  }

  &__modal {
    width: 480px;
    padding: 40px;

    @include mobile {
      padding: 16px;
      width: 320px;
    }
  }

  &__title {
    margin-bottom: 24px;
    font-size: 26px;
    font-weight: 500;
    line-height: 32px;
    padding-right: 20px;

    @include mobile {
      padding-right: 30px;
    }
  }

  &__modal-body {
    display: flex;
    align-items: center;
    margin-bottom: 32px;
  }

  &__person {
    margin-right: 24px;
    height: 72px;
    width: 72px;
    border-radius: 50%;
    flex-shrink: 0;
    object-fit: cover;
  }

  &__text {
    font-size: 16px;
    line-height: 24px;
  }

  &__actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 24px;
  }
}
</style>